import { cn } from "@/lib/utils"

interface DotPillProps {
  label: string
  /** CSS variable name for the dot color, e.g. "--stage-drafting" */
  dotVar: string
  className?: string
}

// Muted pill with a colored dot prefix — quieter than filled badges, faster to
// scan. Used for bid status/priority in the bids table and the overview
// metadata strip. CSS variables are read via inline style because Tailwind JIT
// can't see dynamic class names.
export function DotPill({ label, dotVar, className }: DotPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 bg-muted text-foreground rounded-lg px-2.5 py-0.5 text-xs font-medium",
        className
      )}
    >
      <span
        className="h-1.5 w-1.5 rounded-full shrink-0"
        style={{ backgroundColor: `hsl(var(${dotVar}))` }}
      />
      {label}
    </span>
  )
}
